import { render, staticRenderFns } from "./ProfileFields.vue?vue&type=template&id=c36a5276"
import script from "./ProfileFields.vue?vue&type=script&lang=js"
export * from "./ProfileFields.vue?vue&type=script&lang=js"
import style0 from "./ProfileFields.vue?vue&type=style&index=0&id=c36a5276&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports